const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;

const isMobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile|WPDesktop/i));

export default isMobile;
